export default {
  data() {
    return {
      companies: {
        loading: false,
        pagination: {
          page: 1,
          perPage: 10,
          total: 0,
          totalPages: 0,
        },
        details: {},
        list: [],
        filters: {
          users: {
            list: [],
            selected: [],
          },
          status: {
            list: [
              {
                label: "Ativo",
                value: "Ativo",
              },
              {
                label: "Desativado",
                value: "Desativado",
              },
            ],
            selected: [],
          },
          period: {
            selected: [],
          },
          searchTerm: "",
          order: "desc",
          orderBy: "created",
        },
      },
    };
  },
  methods: {
    changeCompaniesPage(current) {
      this.companies.pagination.page = current;
      this.getCompanies();
    },
    changeCompaniesPageSize(current, pageSize) {
      this.companies.pagination.page = current;
      this.companies.pagination.perPage = pageSize;
      this.getCompanies();
    },
    companiesTableChange(pagination, filters, sorter) {
      filters;
      pagination;
      this.companies.filters.order =
        sorter.order != undefined ? sorter.order : "desc";
      this.companies.filters.orderBy =
        sorter.column != undefined ? sorter.column.key : "created";
      this.getCompanies();
    },
    getCompanies(samePage) {
      let filters = "";

      this.companies.loading = true;

      if (this.companies.filters.searchTerm) {
        filters += `&s=${this.companies.filters.searchTerm}`;
      }

      if (this.companies.filters.status.selected.length > 0) {
        filters += `&status=${this.companies.filters.status.selected}`;
      }

      if (this.companies.filters.users.selected.length > 0) {
        filters += `&user_id=${this.companies.filters.users.selected}`;
      }

      filters += `&order=${this.companies.filters.order}&order-by=${this.companies.filters.orderBy}`;

      this.$http
        .get(
          `/company/list?page=${this.companies.pagination.page}&per_page=${this.companies.pagination.perPage}${filters}`
        )
        .then(({ data }) => {
          if (!samePage) {
            this.companies.pagination.page = 1;
          }
          this.companies.pagination.total = data.meta.total;
          this.companies.pagination.totalPages = data.meta.total_pages;
          this.companies.list = data.data;
          this.companies.loading = false;
        })
        .catch(({ response }) => {
          this.companies.loading = false;
          this.companies.list = response.data.data;
          this.companies.pagination.total = response.data.meta.total;
          this.companies.pagination.totalPages = response.data.meta.total_pages;
        });
    },
  },
};
